import React, { useState, useEffect } from "react";
import emailjs from "emailjs-com"; // Import EmailJS

const PopUp = ({ isOpen, onClose, setShowSecondaryPopup }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false); // Loading state

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true); // Show modal
    } else {
      const timer = setTimeout(() => {
        setIsVisible(false); // Hide modal after animation completes
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  const [formData, setFormData] = useState({
    name: "",
    contactNumber: "",
    email: "",
    description: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Check for empty fields
    const { name, contactNumber, email, description } = formData;
    if (!name || !contactNumber || !email || !description) {
      alert("Por favor, preencha todos os campos antes de enviar."); // Display a friendly alert
      return;
    }

    setIsSubmitting(true); // Start loading

    // Sending email using EmailJS
    emailjs
      .send(
        "service_car1818", // Your service ID
        "template_p8rqi7d", // Your template ID
        formData, // Data to send
        "4rtjRoUk0Hs2FMcmO" // Your user ID (from EmailJS)
      )
      .then((response) => {
        console.log("O pedido foi enviado com sucesso!", response.status, response.text);
        setIsSubmitting(false); // Stop loading
        setFormData({
          name: "",
          contactNumber: "",
          email: "",
          description: "",
        }); // Clear all fields
        setTimeout(() => {
          setShowSecondaryPopup(true);
        }, 300); // Delay to simulate smooth transition
        onClose(); // Close modal after submission
      })
      .catch((err) => {
        console.error("Houve um erro ao enviar o pedido. Tente novamente!", err);
        setIsSubmitting(false); // Stop loading in case of error
      });
  };

  if (!isVisible) return null; // Do not render if not visible

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center transition-opacity duration-300 ${
        isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
    >
      <div className="absolute inset-0 bg-black opacity-70"></div>
      <div
        className={`bg-cyan-700 p-8 rounded-lg shadow-lg relative z-10 max-w-md w-full transform transition-all duration-300 ${
          isOpen
            ? "opacity-100 translate-y-0 scale-100"
            : "opacity-0 translate-y-10 scale-90"
        }`}
      >
        <h2 className="text-2xl font-bold text-white mb-4">Contact Us</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="name" className="block text-white font-bold mb-2">
              Nome Completo
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded text-black"
              placeholder="Digite o nome completo" // Placeholder for name input
              required
            />
          </div>
          <div className="mb-4">
            <label
              htmlFor="contactNumber"
              className="block text-white font-bold mb-2"
            >
              Contacto
            </label>
            <input
              type="tel"
              name="contactNumber"
              value={formData.contactNumber}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded text-black"
              placeholder="Digite o número de contacto" // Placeholder for contact number input
              required
            />
          </div>
          <div className="mb-4">
            <label htmlFor="email" className="block text-white font-bold mb-2">
              E-mail
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded text-black"
              placeholder="Digite o e-mail" // Placeholder for email input
              required
            />
          </div>
          <div className="mb-4">
            <label
              htmlFor="description"
              className="block text-white font-bold mb-2"
            >
              Pedido
            </label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded text-black"
              rows="4"
              placeholder="Descreva o pedido" // Placeholder for description textarea
              required
            ></textarea>
          </div>

          <button
            type="submit"
            className="bg-cyan-600 text-white font-bold py-2 px-4 rounded-md hover:bg-cyan-500 flex items-center justify-center"
            disabled={isSubmitting} // Disable button while submitting
          >
            {isSubmitting ? (
              <svg
                className="animate-spin h-5 w-5 mr-2 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                ></path>
              </svg>
            ) : (
              "Enviar"
            )}
          </button>

          <button
            type="button"
            onClick={onClose}
            className="absolute top-2 right-2 text-white font-bold hover:text-white hover:bg-cyan-500 bg-cyan-600"
          >
            &#x2715; {/* Close icon */}
          </button>
        </form>
      </div>
    </div>
  );
};

export default PopUp;
